import { Injectable } from '@angular/core';
import { impactInterface, requestClassificationInterface } from 'src/app/util/interfaces/requestClassification';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';

export interface searchDefaultImpactDTO {
	idTopic: string;
	idSolutionArea: string;
	scope: string;
	defaultImpact: string;
	category: string;
	topic: string;
}

@Injectable({
	providedIn: 'root',
})
export class DefaultImpactService {
	private defaultImpactUrl = environment.baseApiUrl + 'register/customer/defaultImpact';
	private availableImpactUrl = environment.baseApiUrl + 'register/customer/defaultImpact/available';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	searchClassifications(classification: requestClassificationInterface): Observable<searchDefaultImpactDTO[]> {
		return this.http.get<searchDefaultImpactDTO[]>(this.defaultImpactUrl, {
			headers: this.headers,
			params: {
				solution_area: classification.solutionArea[0] ? classification.solutionArea[0].id : '',
				scope: classification.scope[0] ? classification.scope[0].id : '',
				category: classification.category[0] ? classification.category[0].id : '',
				topic: classification.topic[0] ? classification.topic[0].id : '',
			},
		});
	}

	getAvailableImpact(idCustomer: string): Observable<impactInterface[]> {
		return this.http.get<impactInterface[]>(this.availableImpactUrl, { headers: this.headers, params: { idCustomer: idCustomer } });
	}

	saveDefaultImpact(defaultUrgencyArray: searchDefaultImpactDTO[]): Observable<any> {
		return this.http.put<any>(this.defaultImpactUrl, defaultUrgencyArray, { headers: this.headers });
	}
}
